import { Component, inject, signal } from '@angular/core';
import { FooterComponent } from '../../body/footer/footer.component';
import { NavbarComponent } from '../../body/navbar/navbar.component';
import { SidebarComponent } from '../../body/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav'
import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    SidebarComponent,
    NavbarComponent,
    FooterComponent,
    BreadcrumbComponent,
    BreadcrumbItemDirective,
    TranslateModule
  ],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {
  private breakpointObserver = inject(BreakpointObserver);

  isSidebarOpen$ = signal(false);
  isMobile$ = signal(false);

  constructor() {
    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile$.set(result.matches);
      });
  }

  toggleSidebar() {
    this.isSidebarOpen$.update(isOpen => !isOpen);
  }
}